import { ReactNode } from 'react'
import { useField } from 'formik'
import { useTranslation } from 'react-i18next'
import { Grid, Typography } from '@mui/material'
import { PaperSection, type SelectableCardData } from '~/widgets'
import { getErrorMessage } from '~/components'
import { SelectableCardItem } from './SelectableCardItem'

type Props<T> = {
  fieldName: string
  title: string
  items: Array<SelectableCardData<T>>
  showRequiredDataLabel: boolean
}

export const SelectableCardList: <T extends string>(props: Props<T>) => ReactNode = ({
  fieldName,
  title,
  items,
  showRequiredDataLabel,
}) => {
  const { t } = useTranslation()
  const [field] = useField(fieldName)

  return (
    <PaperSection title={title}>
      {showRequiredDataLabel ? (
        <Typography sx={{ marginTop: -1 }}>{t('firstFillAbove')}</Typography>
      ) : (
        <>
          <Grid container direction="row" size={{ xs: 12 }} columnSpacing={2}>
            {items.map((item) => (
              <Grid key={item.value} size={{ xs: 12, sm: 6 }}>
                <SelectableCardItem
                  item={item}
                  isSelected={field.value === item.value}
                  onClick={() => field.onChange(field.name)(item.value)}
                  testId={`selectableCard-${fieldName}-${item.value}`}
                />
              </Grid>
            ))}
          </Grid>
          {getErrorMessage(fieldName)}
        </>
      )}
    </PaperSection>
  )
}
